import axios from "axios";

const API = `${process.env.REACT_APP_API_URL || "http://localhost:5001"}/api/assets`;

export const createAssetApi = (data) => axios.post(API, data);
export const updateAssetApi = (id, data) => axios.patch(`${API}/${id}`, data);
export const deleteAssetApi = (id) => axios.delete(`${API}/${id}`);

// Streams the .xlsx through axios (so the auth + x-project-id headers ride
// along) and hands it to the browser as a download.
export const downloadAssetsExcel = async (params = {}) => {
  const res = await axios.get(`${API}/export`, { params, responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "assets.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const bulkUploadAssetsApi = (file, projectId) => {
  const fd = new FormData();
  fd.append("file", file);
  if (projectId) fd.append("projectId", projectId);
  return axios.post(`${API}/bulk-upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const downloadAssetTemplate = async () => {
  const res = await axios.get(`${API}/template`, { responseType: "blob" });
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = "assets-template.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
